import { AdminApi } from 'stylemix-vue-admin'

export default class LogsApi extends AdminApi {
  constructor(endpoint, parameters) {
    super('logs', parameters)
  }

  all(config = {}) {
    return this.submit('get', `/${this.endpoint}`, config)
  }
}
